module.exports = __webpack_public_path__ + "static/media/Ship-Meraviglia-MSC-aurea-spa.3846acfc.webp";